import styled from "styled-components";

export default styled.textarea`
  height: ${props => props.height || "auto"};
  width: ${props => props.width || "auto"};
  min-height: 24px;
  padding: 0.2rem 0.2rem 0.2rem 0.2rem;
  font-size: 11px;
  line-height: normal;
  border: 1px solid ${props => props.theme.input.border};
  background-color: ${props => props.theme.input.background};
  border-radius: 0;
  color: ${props => props.theme.input.text};
  margin: 0;
`;



// WEBPACK FOOTER //
// ./app/styled-components/TextArea.js